import {injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {SubtenantExtensionConfigurationModel} from './SubtenantExtensionConfiguration.model';

@injectable()
export class SubtenantExtensionConfigurationFactory
  implements
    BaseDomainFactory<
      SubtenantExtensionConfigurationModel,
      SubtenantExtensionConfigurationModel.Props
    >
{
  create(
    props: SubtenantExtensionConfigurationModel.Props,
  ): SubtenantExtensionConfigurationModel {
    return new SubtenantExtensionConfigurationModel(props);
  }

  createEmpty(): SubtenantExtensionConfigurationModel {
    return new SubtenantExtensionConfigurationModel({
      behavior: 'evergreen',
      id: '',
    });
  }
}
